import classNames from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { ReactComponent as IconNotice } from '../../../../assets/images/notice.svg';
import { loadersByName } from '../../../../store/ui';
import ControlViews, { ControlViewsProps } from '../controlViews';
import './index.scss';
import Loading from '../Loading';

interface OwnProps {
    controls: ControlViewsProps;
    counter: {
        showingNow: number;
        total: number;
    };
}

type Props = OwnProps;

const ControlViewsLocation: FC<Props> = ({ counter, controls }) => {
    const intl = useIntl();
    const locationLoading = useSelector(loadersByName('location'));

    return (
        <div className={classNames('controls_wrapper', { ['controls_wrapper--horizon-mode']: !controls.toggle })}>
            <div>
                <div className={'counter__wrapper'}>
                    {locationLoading ? (
                        <>
                            {intl.formatMessage({ id: 'general.showing', defaultMessage: 'Angezeigt' })}
                            <Loading style={{ maxWidth: 25, margin: '0 0 0 10px' }} relative />
                        </>
                    ) : (
                        intl.formatMessage(
                            { id: 'general.counterView', defaultMessage: '{showingNow} von {total} Ergebnissen' },
                            { ...counter }
                        )
                    )}
                </div>

                <div className={'controls_wrapper--group'}>
                    <ControlViews {...controls} />
                </div>
            </div>

            <div className={'info__wrapper'}>
                <IconNotice />
                {intl.formatMessage({
                    id: 'general.addingProducts',
                    defaultMessage: "Verwenden Sie das '+', um Produkte zu Ihrer Auswahl hinzuzufügen",
                })}
            </div>
        </div>
    );
};

export default ControlViewsLocation;
